module.exports = __webpack_public_path__ + "img/cannes-25.2e4a5346.png";